import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

// Declare the Twitter pixel function
declare let twq: Function;

@Injectable({
  providedIn: 'root',
})
export class TwitterPixelService {
  private isProductionSite =
    window.location.origin === 'https://cleverdeals.net';

  private readonly eventId = 'tw-pzthv-pzthw';

  /**
   * Track user registration/signup completion
   */
  trackCompleteRegistration(customerEmailAddress: string, customerId: string) {
    console.log(typeof twq, this.isProductionSite);
    if (this.isProductionSite && typeof twq !== 'undefined') {
      twq('event', this.eventId, {
        value: null,
        currency: environment.paymentCurrency,
        conversion_id: `registration_${customerId}`,
        email_address: customerEmailAddress || null,
      });
    }
  }

  /**
   * Track when user initiates checkout process
   */
  trackInitiateCheckout(
    reservationId?: number,
    customerId?: number,
    value?: number,
    currency: string = environment.paymentCurrency
  ) {
    if (this.isProductionSite && typeof twq !== 'undefined') {
      twq('event', this.eventId, {
        value: value || null,
        currency: currency || null,
        conversion_id:
          `checkout_${reservationId}` || this.generateConversionId('checkout'),
        email_address: customerId,
      });
    }
  }

  /**
   * Track completed purchases
   */
  trackPurchase(
    value: number,
    reservationId?: number,
    currency: string = environment.paymentCurrency
  ) {
    if (this.isProductionSite && typeof twq !== 'undefined') {
      twq('event', this.eventId, {
        value: value,
        currency: currency,
        conversion_id:
          `reservation_success_${reservationId}` ||
          this.generateConversionId('purchase'),
      });
    }
  }

  private generateConversionId(eventType: string): string {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substr(2, 9);
    return `${eventType}_${timestamp}_${random}`;
  }
}
